import { useEffect, useState } from 'react';

export default function QuestionContextV2({
  title,
  content,
}: {
  title: string;
  content: string;
}) {
  const [show, setShow] = useState(false);
  const [transitionClass, setTransitionClass] = useState('');
  const widthClasses = 'w-[22px] h-[22px] min-w-[22px] min-h-[22px]';
  const color = 'black';

  useEffect(() => {
    setTransitionClass('');
    setShow(false);
  }, [title, content]);

  return (
    <>
      <div className="hidden md:flex items-center w-full md:w-[805px] bg-[#FBE9C9] text-black px-10 py-6 rounded-xl md:rounded-2xl md:mt-[-25px] md:pt-[50px]">
        <div className="min-w-fit short:min-w-0 short:w-full">
          <p className="text-[16px] min-w-fit">{title}</p>
        </div>
        <div className="h-[60px] w-[1px] bg-white mx-4"></div>
        <div>
          <p className="text-[14px]">{content}</p>
        </div>
      </div>

      <div className="md:hidden flex-col bg-[#FBE9C9] text-black rounded-xl mt-[-20px] p-6 pt-[40px] items-center">
        <div className="flex justify-between gap-2">
          <p className="text-[16px]">{title}</p>
          <div
            className={
              show
                ? `rotate-90 ${widthClasses}`
                : `rotate-[270deg] ${widthClasses}`
            }
            onClick={() => {
              setTransitionClass('transition-[max-height] duration-300');
              setShow(!show);
            }}>
            <svg
              width="100%"
              height="100%"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" />
              <path
                d="M11.5 7L8.5 10L11.5 13"
                stroke={color || 'black'}
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <rect
                x="0.5"
                y="0.5"
                width="19"
                height="19"
                rx="9.5"
                stroke={color || 'black'}
              />
            </svg>
          </div>
        </div>
        <div
          className={`${
            show ? 'max-h-[1000px]' : 'max-h-[0px]'
          } overflow-hidden ${transitionClass}`}>
          <p className="pt-4 text-[14px]">{content}</p>
        </div>
      </div>
    </>
  );
}
